// The Foundation label classes for a result: green for a win, blue for a draw,
// red for a loss and grey for anything else.
export const resultLabelClass = (result) => {
  if (result === "W") {
    return "round radius label success";
  } else if (result === "D") {
    return "round radius label warning";
  } else if (result === "L") {
    return "round radius label alert";
  } else {
    return "round radius label secondary";
  }
};
